import { Fragment } from 'react';
import type { Segment } from '../content/story';

/** Renders a segmented paragraph, preserving the original bold/italic emphasis. */
export function Prose({ segments }: { segments: Segment[] }) {
  return (
    <>
      {segments.map((segment, index) => {
        if (segment.emphasis === 'strong') {
          return (
            <strong key={index} className="font-semibold text-ink">
              {segment.text}
            </strong>
          );
        }

        if (segment.emphasis === 'em') {
          return <em key={index}>{segment.text}</em>;
        }

        return <Fragment key={index}>{segment.text}</Fragment>;
      })}
    </>
  );
}
